export enum BuiltInAiApiEnum {
  LanguageDetector = "LANGUAGE_DETECTOR",
  Prompt = "PROMPT",
  Proofreader = "PROOFREADER",
  Rewriter = "REWRITER",
  SemanticEmbedder = "SEMANTIC_EMBEDDER",
  Summarizer = "SUMMARIZER",
  Translator = "TRANSLATOR",
  Writer = "WRITER",
}
